import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMute: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMute"><Path d="M3.74816 21.3108L21.3088 3.75011L20.2482 2.68945L17 5.93761V2.9707L9.8043 7.0003H5V17.0003H5.93732L2.6875 20.2501L3.74816 21.3108Z" fill="currentColor"/><Path d="M17 21.0299L10.0454 17.1353L17 10.1806V21.0299Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMute;
